import { render } from "./MoreBook.vue?vue&type=template&id=40b609c8&scoped=true"
import script from "./MoreBook.vue?vue&type=script&lang=js"
export * from "./MoreBook.vue?vue&type=script&lang=js"

import "./MoreBook.vue?vue&type=style&index=0&id=40b609c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b609c8"]])

export default __exports__